<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">城市映射查询</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openEditor()">新增映射</el-button>
      </div>
      <div class="life-filter">
        <el-select
          v-model="filters.communityId"
          placeholder="全部小区"
          clearable
          filterable
          style="width: 200px"
        >
          <el-option
            v-for="item in communityOptions"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
        <el-input v-model="filters.cityId" placeholder="城市 ID" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">城市映射</h2>
        <span class="life-muted">运营按小区配置啄木鸟城市（下单城市取此映射；手输地址不逆地理）</span>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="communityName" label="小区" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.communityName || scope.row.communityId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="cityId" label="城市 ID" width="120" />
        <el-table-column prop="regionName" label="行政区" min-width="140" />
        <el-table-column label="可服务" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.serviceable === 'Y' ? 'success' : 'info'" size="small">
              {{ scope.row.serviceable === 'Y' ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>

    <el-dialog :title="form.mapId ? '编辑城市映射' : '新增城市映射'" :visible.sync="editorVisible" width="500px" @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="小区" prop="communityId">
          <el-select
            v-model="form.communityId"
            placeholder="请选择小区"
            filterable
            style="width: 100%"
            :disabled="!!form.mapId"
          >
            <el-option
              v-for="item in communityOptions"
              :key="item.communityId"
              :label="item.name"
              :value="item.communityId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="城市 ID" prop="cityId">
          <el-input v-model="form.cityId" maxlength="32" />
        </el-form-item>
        <el-form-item label="行政区">
          <el-input v-model="form.regionName" maxlength="64" />
        </el-form-item>
        <el-form-item label="可服务" prop="serviceable">
          <el-radio-group v-model="form.serviceable">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listCityMaps, saveCityMap, updateCityMap, deleteCityMap } from '@/api/life/homeServiceApi'
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'

function emptyForm() {
  return { mapId: '', communityId: '', cityId: '', regionName: '', serviceable: 'Y' }
}

export default {
  name: 'HomeServiceCityMapList',
  data() {
    return {
      loading: false, saving: false, editorVisible: false,
      rows: [],
      communityOptions: [],
      filters: { communityId: '', cityId: '' },
      page: { current: 1, size: 10, total: 0 },
      form: emptyForm(),
      rules: {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        cityId: [{ required: true, message: '请输入城市 ID', trigger: 'blur' }],
        serviceable: [{ required: true, message: '请选择是否可服务', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadCommunities()
    this.load()
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await listAdminCommunitys({ page: 1, row: 500 })
        this.communityOptions = res.data || []
      } catch (_) {
        this.communityOptions = []
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listCityMaps({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载城市映射列表失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { communityId: '', cityId: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() },
    openEditor(row) {
      this.form = row ? { ...row } : emptyForm()
      this.editorVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.form = emptyForm()
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          if (this.form.mapId) {
            await updateCityMap(this.form)
          } else {
            await saveCityMap(this.form)
          }
          this.$message.success('城市映射已保存')
          this.editorVisible = false
          this.load()
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        } finally { this.saving = false }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除城市映射「${row.cityId}」？`, '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteCityMap({ mapId: row.mapId })
          this.$message.success('已删除')
          if (this.rows.length === 1 && this.page.current > 1) this.page.current--
          this.load()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/views/lifeService/life.scss';
</style>
